module.exports = __webpack_public_path__ + "static/media/j2bd.7edb23b0.svg";